var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("el-page-header", {
                attrs: { content: "对账单详情" },
                on: { back: _vm.goBack },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "基本信息", name: "basic" } },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.detailLoading,
                          expression: "detailLoading",
                        },
                      ],
                    },
                    [
                      _c(
                        "el-descriptions",
                        {
                          staticClass: "mb20",
                          attrs: { column: 3, border: "", size: "small" },
                        },
                        [
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "对账单号" } },
                            [_vm._v(_vm._s(_vm.detail.statementNo || "-"))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "商家名称" } },
                            [_vm._v(_vm._s(_vm.detail.merchantName || "-"))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "商家ID" } },
                            [_vm._v(_vm._s(_vm.detail.merchantId || "-"))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "商家类型" } },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.merchantTypeTagType(
                                      _vm.detail.merchantType
                                    ),
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.merchantTypeText(
                                          _vm.detail.merchantType
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "账单周期" } },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.detail.periodDesc || "-") +
                                  "\n            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "结算方式" } },
                            [
                              _vm._v(
                                _vm._s(_vm.cycleTypeText(_vm.detail.cycleType))
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "对账状态" } },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.reconciliationStatusTagType(
                                      _vm.detail.reconciliationStatus
                                    ),
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.reconciliationStatusText(
                                          _vm.detail.reconciliationStatus
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "打款状态" } },
                            [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type: _vm.paymentStatusTagType(
                                      _vm.detail.paymentStatus
                                    ),
                                    size: "small",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.paymentStatusText(
                                          _vm.detail.paymentStatus
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "创建时间" } },
                            [_vm._v(_vm._s(_vm.detail.createTime || "-"))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "确认时间" } },
                            [_vm._v(_vm._s(_vm.detail.confirmTime || "-"))]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-descriptions-item",
                            { attrs: { label: "结算时间" } },
                            [_vm._v(_vm._s(_vm.detail.settlementTime || "-"))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "amount-summary" }, [
                        _c("div", { staticClass: "summary-title" }, [
                          _vm._v("金额汇总"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "summary-content" }, [
                          _c("div", { staticClass: "summary-row" }, [
                            _c("div", { staticClass: "summary-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("商品总金额"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value income" }, [
                                _vm._v(
                                  "+￥" +
                                    _vm._s(
                                      _vm.formatAmount(_vm.detail.productAmount)
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "summary-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("运费总额"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value income" }, [
                                _vm._v(
                                  "+￥" +
                                    _vm._s(
                                      _vm.formatAmount(_vm.detail.freightAmount)
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "summary-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("平台补贴"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value income" }, [
                                _vm._v(
                                  "+￥" +
                                    _vm._s(
                                      _vm.formatAmount(
                                        _vm.detail.platformSubsidy
                                      )
                                    )
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "summary-row" }, [
                            _c("div", { staticClass: "summary-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("退款金额"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value expense" }, [
                                _vm._v(
                                  "-￥" +
                                    _vm._s(
                                      _vm.formatAmount(_vm.detail.refundAmount)
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "summary-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("售后扣款"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value expense" }, [
                                _vm._v(
                                  "-￥" +
                                    _vm._s(
                                      _vm.formatAmount(
                                        _vm.detail.afterSalesAmount
                                      )
                                    )
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "summary-item" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("平台服务费"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "value expense" }, [
                                _vm._v(
                                  "-￥" +
                                    _vm._s(
                                      _vm.formatAmount(_vm.detail.serviceFee)
                                    )
                                ),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "summary-divider" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "summary-total" }, [
                            _c("span", { staticClass: "total-label" }, [
                              _vm._v("实际应结"),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "total-value" }, [
                              _vm._v(
                                "￥" +
                                  _vm._s(
                                    _vm.formatAmount(_vm.detail.actualAmount)
                                  )
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.detail.bankName || _vm.detail.bankAccount
                        ? _c(
                            "div",
                            { staticClass: "bank-info" },
                            [
                              _c("div", { staticClass: "info-title" }, [
                                _vm._v("结算账户信息"),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-descriptions",
                                {
                                  attrs: {
                                    column: 4,
                                    border: "",
                                    size: "small",
                                  },
                                },
                                [
                                  _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "银行名称" } },
                                    [_vm._v(_vm._s(_vm.detail.bankName || "-"))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "银行账号" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.detail.bankAccount || "-")
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "开户行" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.detail.bankBranch || "-")
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-descriptions-item",
                                    { attrs: { label: "开户姓名" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.detail.accountName || "-")
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "remark-section" },
                        [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("对账备注")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "remark-box" }, [
                            _vm._v(
                              _vm._s(
                                _vm.detail.reconciliationRemark ||
                                  "暂无对账备注"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [_vm._v("财务备注")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "remark-box" }, [
                            _vm._v(
                              _vm._s(
                                _vm.detail.financialRemark || "暂无财务备注"
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "btn-wrap" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.goBack },
                            },
                            [_vm._v("返回列表")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleDownload },
                            },
                            [_vm._v("下载账单明细")]
                          ),
                          _vm._v(" "),
                          _vm.detail.status === 0
                            ? _c(
                                "el-button",
                                {
                                  attrs: { size: "small", type: "success" },
                                  on: { click: _vm.handleConfirm },
                                },
                                [_vm._v("确认对账单")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "订单明细", name: "orders" } },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "mb15",
                      attrs: {
                        inline: "",
                        size: "small",
                        model: _vm.orderPram,
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "订单号：" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              placeholder: "请输入订单号",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.getOrderList($event)
                              },
                            },
                            model: {
                              value: _vm.orderPram.orderNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.orderPram, "orderNo", $$v)
                              },
                              expression: "orderPram.orderNo",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.getOrderList },
                            },
                            [_vm._v("搜索")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            { on: { click: _vm.handleResetOrder } },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.orderLoading,
                          expression: "orderLoading",
                        },
                      ],
                      attrs: {
                        data: _vm.orderListData.list,
                        size: "mini",
                        "header-cell-style": { fontWeight: "bold" },
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderNo",
                          label: "订单号",
                          "min-width": "160",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-link",
                                  {
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleOrderDetail(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.orderNo))]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "createTime",
                          label: "下单时间",
                          "min-width": "160",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "finishTime",
                          label: "完成时间",
                          "min-width": "160",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "userNickname",
                          label: "用户昵称",
                          "min-width": "120",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "productName",
                          label: "商品名称",
                          "min-width": "160",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "skuSpec",
                          label: "SKU规格",
                          "min-width": "120",
                          "show-overflow-tooltip": "",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "quantity",
                          label: "数量",
                          "min-width": "80",
                          align: "center",
                        },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "productAmount",
                          label: "商品金额",
                          "min-width": "120",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "￥" +
                                    _vm._s(
                                      _vm.formatAmount(scope.row.productAmount)
                                    )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "freightAmount",
                          label: "运费",
                          "min-width": "100",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "￥" +
                                    _vm._s(
                                      _vm.formatAmount(scope.row.freightAmount)
                                    )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "discountAmount",
                          label: "优惠金额",
                          "min-width": "120",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "-￥" +
                                    _vm._s(
                                      _vm.formatAmount(scope.row.discountAmount)
                                    )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "serviceFee",
                          label: "服务费",
                          "min-width": "100",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "-￥" +
                                    _vm._s(
                                      _vm.formatAmount(scope.row.serviceFee)
                                    )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "refundAmount",
                          label: "退款金额",
                          "min-width": "120",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  "-￥" +
                                    _vm._s(
                                      _vm.formatAmount(scope.row.refundAmount)
                                    )
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "actualSettlementAmount",
                          label: "实际结算金额",
                          "min-width": "130",
                          align: "right",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "#E6A23C",
                                      "font-weight": "bold",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "￥" +
                                        _vm._s(
                                          _vm.formatAmount(
                                            scope.row.actualSettlementAmount
                                          )
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "orderStatus",
                          label: "订单状态",
                          "min-width": "100",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-tag",
                                  {
                                    attrs: {
                                      type: _vm.orderStatusType(
                                        scope.row.orderStatus
                                      ),
                                      size: "small",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.orderStatusDesc ||
                                            scope.row.orderStatus
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.orderPram.page,
                      "page-sizes": [10, 20, 30, 50],
                      "page-size": _vm.orderPram.limit,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.orderListData.total,
                    },
                    on: {
                      "size-change": _vm.handleOrderSizeChange,
                      "current-change": _vm.handleOrderCurrentChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("DownloadRecordDialog", { ref: "downloadDialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }